<template>
  <div class="main">
    <div class="details">
      <div class="result line_bottom">
        <div class="title">
          <div>待线下通知整改</div>
          <!-- <div class="remainDay" v-if="format.taskType !== 11">剩余{{format.planTime}}天</div> -->
        </div>
        <div class="auditResults">该企业已列为重点关注企业，请线下通知商户进行整改</div>
      </div>
      <div class="toBeRectified">
        <div class="companyName line_bottom">
          <div class="left">企业名称</div>
          <div class="right" @click="goTaskDetail">
            <span>{{contentData.name}}</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
        <div class="jurisdiction line_bottom">
          <div class="left">所属辖区</div>
          <div class="right">{{contentData.regionName}}</div>
        </div>
        <div class="supervisionDate line_bottom">
          <div class="left">进入重点关注日期</div>
          <div class="right" v-show='contentData.planTime'>{{contentData.planTime|filtTime}}</div>
        </div>
        <div class="integrityIndex">
          <div class="left">
            <span class="className">诚信指数</span>
            <span class="num">{{contentData.memo ? Number(contentData.memo).toFixed(2) : ''}}</span>
            <span class="unit">分</span>
          </div>
          <div class="right">
            <span @click="goGradeDetail">评分详情</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="status" @click="changeBtn" v-show="!contentData.isHandle">我知道了</div>
      <div class="status saw"  v-show="contentData.isHandle">已知悉</div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    import apimessage from '../../../../service/modules/message'
    export default {
        data () {
            return {
                saw: true,
                title: '',
                format: {},
                taskId: '',
                id: '',
                contentData: {}, // 基础数据
                btnFlag: false // 控制按钮重复提交
            };
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            // this.statuses()
            this.taskId = this.$route.query.taskId;
            this.id = this.$route.query.id;
            this.handleList();
        },
        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            changeBtn () {
                api.taskKnow({ id: this.id }).then(res => {
                    if (res.ret === 0) {
                        this.$toast('该条待办已标记为完成');
                        this.contentData.isHandle = !this.contentData.isHandle;
                    }
                });
            },
            handleList () {
                let parm = {
                    id: this.id
                };
                api.taskDetails(parm).then(res => {
                    if (res.ret === 0) {
                        this.contentData = res.data;
                    }
                });
            },
            // 企业名称
            goTaskDetail () {
                this.$router.push({
                    path: 'enterpriseDetail',
                    query: {
                        enterpriseId: this.contentData.taskId
                    }
                });
            },
            // 线下整改 与 重新评分的 查看详情
            goGradeDetail () {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.contentData.taskId
                    }
                });
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  color: #333;
  width: 100%;
  min-height: 100%;
  background-color: #fbfbfb;
  padding: 21px 12px 84px 12px;
  box-sizing: border-box;
  float: left;
  .details {
    width: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    .result {
      width: 100%;
      padding: 16px 16px 13px 16px;
      min-height: 72px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        .remainDay {
          color: #ff8c19;
          font-size: 12px;
        }
      }
      .auditResults {
        border-radius: 3px;
        font-size: 12px;
        font-weight: 400;
        color: #ff8c19;
        margin-top: 9px;
        line-height: 18px;
      }
    }
    .specificContent {
      width: 100%;
      padding: 15px 16px;
      .title {
        font-weight: 400;
        font-size: 14px;
        color: #999;
      }
      .content {
        margin-top: 8px;
        font-size: 14px;
        color: #333;
        font-weight: 400;
        line-height: 22px;
      }
    }
    .missionName {
      padding: 15px 16px;
      margin-top: 5px;
      .title {
        font-size: 14px;
        font-weight: 400;
        color: #999;
      }
      .theme {
        font-size: 14px;
        font-weight: 400;
        margin-top: 12px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .seeDetails {
      padding: 0 16px 15px 16px;
      color: #36b374;
      font-size: 12px;
      font-weight: 400;
      float: left;
      span {
        float: left;
      }
      img {
        float: left;
        display: inline-block;
        width: 14px;
        height: 14px;
      }
    }
    .toBeRectified {
      width: 100%;
      .companyName,
      .jurisdiction,
      .supervisionDate {
        height: 62px;
        width: 100%;
        line-height: 62px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        .left {
          color: #999;
        }
      }
      .jurisdiction{
        .right{
          width: 160px;
          text-align: right;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .companyName {
        line-height: center;
        .right{
          display: flex;
          justify-content: space-around;
          span{
            display: inline-block;
            width: 160px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img{
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top: 24px;
          }
        }
        // .right {
        //   float: right;
        //   span {
        //     display: inline-block;
        //     width: 160px;
        //     overflow: hidden;
        //     white-space: nowrap;
        //     text-overflow: ellipsis;
        //   }
        //   img {
        //     display: inline-block;
        //     width: 12px;
        //     height: 12px;
        //     margin-top: 24px;
        //   }
        // }
      }
      .integrityIndex {
        height: 60px;
        width: 100%;
        line-height: 60px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left{
          display: flex;
          align-items: center;
          .className {
            color: #333;
            font-size: 14px;
            font-weight: 500;
          }
          .num {
            display: inline-block;
            margin-left: 12px;
            color: #ff4d4d;
            font-size: 20px;
            font-weight: bold;
          }
          .unit {
            margin-top: 6px;
            margin-left: 2px;
            color: #ff4d4d;
            font-size: 12px;
            -webkit-transform: scale(0.84);
          }
        }
        .right {
          span {
            float: left;
          }
          img {
            display: inline-block;
            float: right;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top: 24px;
          }
        }
      }
    }
  }
  .bottom {
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
    width: 100%;
    height: 74px;
    background-color: #fff;
    padding: 12px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    .status {
      border-radius: 3px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #36b374;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    .saw {
      opacity: 0.5;
    }
  }
}
</style>
